class RealOwner {
    isRealOwner;
    hasOwnResources;
    realOwnerName;
    realOwnerBirthdate;
    publicOffice;
    departmentOrEntity;
    sourceOfResources;
    maximumAmount;
    hasKinshipWithPEP;
    fullNameOfKinshipRelated;
    typeOfRelationship;
    publicOfficeOfKinship;
    constructor(data) {
        this.isRealOwner = data?.isRealOwner;
        this.hasOwnResources = data?.hasOwnResources;
        this.realOwnerName = data?.realOwnerName;
        this.realOwnerBirthdate = data?.realOwnerBirthdate;
        this.publicOffice = data?.publicOffice;
        this.departmentOrEntity = data?.departmentOrEntity;
        this.sourceOfResources = data?.sourceOfResources;
        this.maximumAmount = data?.maximumAmount;
        this.hasKinshipWithPEP = data?.hasKinshipWithPEP;
        this.fullNameOfKinshipRelated = data?.fullNameOfKinshipRelated;
        this.typeOfRelationship = data?.typeOfRelationship;
        this.publicOfficeOfKinship = data?.publicOfficeOfKinship;
    }
}
export default RealOwner;
